import { configureRequest } from '../../../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../../../networkRequests/apiClient/endpoints'
import env from '../../../../../../networkRequests/apiClient/env.config'
import { UserRole } from '../../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  GetDiscountCodesForAdminErrorResponse,
  GetDiscountCodesForAdminRequest,
  GetDiscountCodesForAdminSuccessResponse
} from './getDiscountCodesForAdmin.types'

export const getDiscountCodesForAdminApi = async (
  request: GetDiscountCodesForAdminRequest
): Promise<GetDiscountCodesForAdminSuccessResponse> => {
  const response = await configureRequest({
    url: urls.admin.getDiscountCodesForAdmin,
    method: 'GET',
    data: request,
    params: {
      page: request.page ?? 1,
      limit: request.limit ?? env.DEFAULT_PAGE_SIZE,
      search: request.search ?? '',
      status: request.status ?? ''
    },
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetDiscountCodesForAdminSuccessResponse
  } else {
    throw response as GetDiscountCodesForAdminErrorResponse
  }
}

export default getDiscountCodesForAdminApi
